export enum CouponCheckboxDatahooks {
  Wrapper = 'coupon-checkbox-wrapper',
  SectionMessage = 'coupo-checkbox-section-message',
  Checkbox = 'coupon-checkbox-checkbox',
}
